import React, { Component } from 'react';
import './ProgressBar.scss';

export default class ProgressBar extends Component {

  render() {
    return (
      <div className="progressbar-container" >
        <div className="progress-indicator" style={{ width: `${(this.props.step / this.props.steps) * 100}%` }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.jsx